import { SearchScopeKind } from 'owa-search-service';
import { action } from 'satcheljs';

const clearSearchScope = action(
    'clearSearchScope',
    (actionSource: string, shouldStartSearch: boolean, searchScopeKind: SearchScopeKind) => ({
        actionSource,
        shouldStartSearch,
        searchScopeKind,
    })
);

export default clearSearchScope;
